import { constants as orderConstants } from 'utils/order';

import { correctTimes as DirectOrdercorrectTimes } from 'state/direct-order/shipments/effects';
import { correctTimes as MrDistributioncorrectTimes } from 'state/mrDistribution/shipments/effects';
import { correctTimes as MrCollectioncorrectTimes } from 'state/mrCollection/shipments/effects';

const correctTimes = {
  [orderConstants.DIRECT_ORDER]: DirectOrdercorrectTimes,
  [orderConstants.DIRECT_ORDER_RECURRING]: DirectOrdercorrectTimes,
  [orderConstants.DISTRIBUTION]: MrDistributioncorrectTimes,
  [orderConstants.COLLECTION]: MrCollectioncorrectTimes,
};

export default {
  correctTimes,
};
